const renderChildren = (props) => props.children;
export default renderChildren;
